import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Card, Alert } from '@mui/material';
import { useAuth } from '../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function ChangePassword() {
    const { ChangePassword, logout } = useAuth();
    const navigate = useNavigate();

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');

        if (newPassword !== confirmPassword) {
            setError('New password and confirmation do not match.');
            return;
        }

        try {
            const authToken = sessionStorage.getItem('authToken');
            if (!authToken) {
                setError('You must be logged in to change your password.');
                return;
            }

            const result = await ChangePassword(currentPassword, newPassword, confirmPassword, authToken);
            if (result === true) {
                setSuccessMessage('Password changed successfully!');
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
                logout();
                navigate('/sign-in');
            } else {
                setError(result?.message || 'Failed to change password. Please try again.');
            }
        } catch (err) {
            setError('An unexpected error occurred.');
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', px: 2, py: { xs: 6, sm: 10 } }}>
            <Card
                variant="outlined"
                sx={{ maxWidth: 450, width: '100%', p: 4, borderRadius: 3 }}
            >
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
                    Change Password
                </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                    label="Current Password"
                    type="password"
                    fullWidth
                    required
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <TextField
                    label="New Password"
                    type="password"
                    fullWidth
                    required
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <TextField
                    label="Confirm New Password"
                    type="password"
                    fullWidth
                    required
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
                {error && <Alert severity="error">{error}</Alert>}
                {successMessage && <Alert severity="success">{successMessage}</Alert>}
                    <Button type="submit" variant="contained" color="primary">
                        Change Password
                    </Button>
                </Box>
            </Card>
        </Box>
    );
}
